import type IAiChatMessage from 'store/slices/aiChats/interfaces/IAiChatMessage';
import type { TAiChatUiMessage } from '../interfaces/IAiChatUiMessage';

/** Prefix of the id given to a row that was stored before the API carried `messageId`. */
const ROW_ID_PREFIX = 'row-';

/** The roles the SDK knows. A row with any other role renders as a reply. */
const KNOWN_ROLES: TAiChatUiMessage['role'][] = ['user', 'assistant', 'system'];

const readRole = (role: string): TAiChatUiMessage['role'] => (
  KNOWN_ROLES.find((known) => known === role) ?? 'assistant'
);

/**
 * A stored row as a message `useChat` can hold.
 *
 * The parts are the same array: the API stores the SDK's own part union. Only the id needs care —
 * a row written before the API carried `messageId` has none, and the row id stands in for it.
 */
const toUiMessage = (row: IAiChatMessage): TAiChatUiMessage => ({
  id: row.messageId || `${ROW_ID_PREFIX}${row.id}`,
  role: readRole(row.role),
  parts: row.parts as TAiChatUiMessage['parts'],
});

export default toUiMessage;
